import * as React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { defaultTheme } from './default-theme';
export var ThemeProvider = function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? defaultTheme : _b, children = _a.children;
    return React.createElement(MuiThemeProvider, { theme: theme }, children);
};
